import { useParams, useNavigate } from 'react-router-dom'
import { SubmitHandler } from 'react-hook-form'

import { AssignmentForm } from '@containers/Forms/Assignment'
import { TAssignmentForm } from '@containers/Forms/Assignment/schema'
import { useAlerts } from '@hooks/alerts'
import { useFindTask } from '@hooks/task/find'
import { useUpdateTaskResource } from '@hooks/task/put/editResource'
import { IGenericAssignment } from '@interfaces/task/generic/IGenericAssignment'

export function AddAssignmentFormScreen() {
  const { showDismissAlert } = useAlerts()
  const { taskId: taskIdParam } = useParams<{ taskId: string }>()
  const taskId = Number(taskIdParam)
  const navigate = useNavigate()

  const { data: rawTask } = useFindTask(taskId)
  const { mutateAsync: putTask } = useUpdateTaskResource()
  const task = rawTask ?? ({} as NonNullable<typeof rawTask>)

  const handleSave: SubmitHandler<TAssignmentForm> = async (
    data: TAssignmentForm,
  ) => {
    const newAssignment: IGenericAssignment = {
      ...data,
      id: 0,
      wasDeleted: false,
      assignees: [],
      assigneeIds: data.assigneeIds ?? [],
      assignmentIds: [],
      description: '',
      offset: 0,
      resourceDescription: '',
      taskId: task.id,
    }

    const assignments = [...task.assignments, newAssignment]

    const payload = {
      id: task.id,
      task: {
        ...task,
        assignments,
      },
    }

    try {
      await putTask(payload)
      navigate(-1)
    } catch {
      window.alert('Error\n\nFailed to add resource. Please try again.')
    }
  }

  function handleClose() {
    showDismissAlert(() => navigate(-1))
  }

  return (
    <AssignmentForm
      onSave={handleSave}
      onClose={handleClose}
      task={task}
      title="Add Resource"
    />
  )
}
